define('drops/calendar/calendarParameter',[],function () {
    'use strict';

    return {
        convert: function (luxonDate) {
            var d = new Date(Date.UTC(
                luxonDate.get('year'),
                luxonDate.get('month') - 1,
                luxonDate.get('day'),
                luxonDate.get('hour'),
                luxonDate.get('minute'),
                luxonDate.get('second')));
            return d;
        }
    };
});

